import { atom } from 'jotai'
import { TypeKeepImageRotated } from 'types/Patient'
import { updateRecords } from 'utils/helper'

export const keepImageRotatedAtom = atom<TypeKeepImageRotated[]>([])

export const upsertKeepImageRotatedAtom = atom(
  null,
  (get, set, record: TypeKeepImageRotated) => {
    const prev = get(keepImageRotatedAtom)
    set(
      keepImageRotatedAtom,
      updateRecords(
        prev,
        [record],
        (a, b) => a.id === b.id && a.type === b.type,
      ),
    )
  },
)
